"use client";
import { Copy01Icon as e } from "../icons/Copy01Icon.js";
import { EyeIcon as t } from "../icons/EyeIcon.js";
import { EyeOffIcon as n } from "../icons/EyeOffIcon.js";
import { XCloseIcon as r } from "../icons/XCloseIcon.js";
import { Fragment as i, jsx as a, jsxs as o } from "react/jsx-runtime";
import { useState as s } from "react";
//#region src/components/fields/FieldAction.tsx
function c({ config: c, value: l, fieldLabel: u, disabled: d, revealed: f, onAction: p }) {
	let [m, h] = s(""), g = c.kind === "reveal" && f ? c.hideLabel ?? `Hide ${u}` : c.label ?? `${c.kind === "copy" ? "Copy" : c.kind === "clear" ? "Clear" : "Show"} ${u}`, _ = c.kind === "copy" ? e : c.kind === "clear" ? r : f ? n : t;
	return /* @__PURE__ */ o(i, { children: [/* @__PURE__ */ a("button", {
		type: "button",
		"aria-label": g,
		"aria-pressed": c.kind === "reveal" ? !!f : void 0,
		disabled: d,
		onClick: () => {
			c.kind === "copy" ? (async () => {
				try {
					await navigator.clipboard.writeText(l), h("Copied"), c.onCopy?.();
				} catch (e) {
					h("Could not copy. Select the text and copy it manually."), c.onCopyError?.(e instanceof Error ? e : /* @__PURE__ */ Error("Clipboard unavailable"));
				}
			})().catch(() => {
				h("Could not copy.");
			}) : p();
		},
		className: "pf:cursor-pointer pf:self-stretch pf:shrink-0 pf:w-[28px] pf:flex pf:items-center pf:justify-center pf:border-0 pf:border-s pf:border-solid pf:border-soft-pearl-400 pf:bg-transparent pf:text-soft-pearl-800 pf:rounded-e-sm pf:hover:bg-soft-pearl-200 pf:focus-visible:outline-2 pf:focus-visible:outline-blue-700 pf:focus-visible:-outline-offset-2 pf:disabled:opacity-50 pf:disabled:cursor-not-allowed",
		children: /* @__PURE__ */ a(_, { size: 16 })
	}), /* @__PURE__ */ a("span", {
		role: "status",
		className: "pf:sr-only",
		children: m
	})] });
}
//#endregion
export { c as FieldAction };
